import axios from "../../config/axiosConfig";
import {
  CREATE_JOB_YARN_RETURN, DELETE_JOB_YARN_RETURN,
  GET_JOB_YARN_RETURN,
  JOB_YARN_RETURN_REQUEST,
  JOB_YARN_RETURN_REQUEST_FAILURE,
  UPDATE_JOB_YARN_RETURN,
  GET_JOB_YARN_RETURNS_PAGE,
  JOB_YARN_RETURN_REQUEST_SUCCESS
} from "../types/job-yarn-return-types";


export const getJobYarnReturnsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RETURN_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Job_Id'
      };
      return axios.get("/job-yarn-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOB_YARN_RETURNS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getJobYarnReturnById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RETURN_REQUEST });
    
      return axios.get(`/job-yarn-return/get/${id}`).then((response) => {
        dispatch({ type: JOB_YARN_RETURN_REQUEST_SUCCESS });
        return response?.data?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJobYarnReturnBeamDetail = (beamNo) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, Beam_No: beamNo };
      return axios.get(`/job-yarn-return/getBeamDetail`, { params }).then((response) => {
        dispatch({ type: JOB_YARN_RETURN_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJobYarnReturnsByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/job-yarn-return/getAll", { params });
      return response?.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getJobYarnReturn = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/job-yarn-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOB_YARN_RETURN, payload: response?.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createJobYarnReturn = (jobYarnReturn) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: JOB_YARN_RETURN_REQUEST });
      const newJobYarnReturn = {
        ...jobYarnReturn
      };
      return axios.post("/job-yarn-return/add", newJobYarnReturn,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_JOB_YARN_RETURN, payload: response.data });
        } else {
          dispatch({
            type: JOB_YARN_RETURN_REQUEST_FAILURE,
            error: "Job Yarn Return create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateJobYarnReturn = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RETURN_REQUEST });
      const { auth } = getState();
      return axios.put("/job-yarn-return/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_JOB_YARN_RETURN,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: JOB_YARN_RETURN_REQUEST_FAILURE,
            error: "Job Yarn Return update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteJobYarnReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOB_YARN_RETURN_REQUEST });
      return axios.delete(`/job-yarn-return/delete/${id}`).then((response) => {
        if (response.data) {
            const include = ['id', 'Entry_No', 'Challan_No', 'Date', 'Account_Id', 'Job_Id'].join(',');
            const searchCols = ['Entry_No'].join(',');
            const { currentPage, pageSize, searchStr, where} = getState()?.inventory?.jobYarnReturn || {};
            dispatch(getJobYarnReturnsWithPagination(currentPage, pageSize, include, searchStr, searchCols, where, true));
            dispatch({ type: DELETE_JOB_YARN_RETURN, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOB_YARN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};